import { createDecorator } from '../../instantiation/common/instantiation.js';
const IURLService = ( createDecorator('urlService'));
export { IURLService };
